import { useParams } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoutes";
import {
  // CircleView,
  CircleViewDashboard,
} from "../allComponents/AllComponents";
import { RoleNames } from "../../utility/types/rolesType";

const CircleRouteWrapper = () => {
  const { circleId } = useParams();

  return (
    <ProtectedRoute
      // component={CircleView}
      component={CircleViewDashboard}
      requiredRoles={[
        RoleNames.ADMIN,
        RoleNames.SUPER_ADMIN,
        RoleNames.UNION_LEADER,
      ]}
      circleId={circleId}
    />
  );
};

export default CircleRouteWrapper;
